import type { AppliedSuggestion } from '@app/src/pages/Questionnaire/Provider/Report/SuggestedAnswers/suggestionSources'
import type { AnswerStatus, ResponseItem } from '@app/src/types/resourceExplorer'
import type React from 'react'
import { createContext, useContext } from 'react'
import type { ResponseItemView } from './ResponseItemContextProvider'

export interface ResponseItemContextProps {
  responseItemView: ResponseItemView
  setResponseItemView: React.Dispatch<React.SetStateAction<ResponseItemView>>
  previousAnswer?: ResponseItem
  appliedSuggestion?: AppliedSuggestion
  setAppliedSuggestion: (suggestion?: AppliedSuggestion) => void
  hideInputField: boolean
  setQuestionSkippedFields: (answerStatus?: AnswerStatus) => void
  sectionNumber: number
  itemNumber: number
}

const ResponseItemContext = createContext<undefined | ResponseItemContextProps>(undefined)

export function useResponseItemContext(): ResponseItemContextProps {
  const context = useContext(ResponseItemContext)
  if (context === undefined) {
    throw new Error('useResponseItemContext must be used within ResponseItemContextProvider')
  }
  return context
}

export default ResponseItemContext
